import { FC, useState } from 'react'

// hooks
import { useAppSelector, useAppDispatch, useInterval } from '@/hooks'
// features
import { authSelectLoading, authSendVerificationEmail } from '@/features'
// libs
import { dateGetDifferenceSec, storageGetSentVerificationEmailDate } from '@/lib'
// components
import { Loader, ButtonLarge } from '@/components'

// styles
import { styles } from './VerificationForm.styles'

type VerificationFormProps = {}

export const VerificationForm: FC<VerificationFormProps> = () => {
  const dispatch = useAppDispatch()
  const authLoading = useAppSelector(authSelectLoading)

  const lastResetSec = dateGetDifferenceSec(
    parseInt(storageGetSentVerificationEmailDate() || '0', 10),
  )
  const delaySec = 30
  const initialSendDelay = lastResetSec > delaySec ? 0 : delaySec - lastResetSec
  const [sendDelay, setSendDelay] = useState(initialSendDelay)

  useInterval(() => {
    if (sendDelay > 0) {
      setSendDelay(sendDelay - 1)
    }
  }, 1000)

  const submitDisabled = sendDelay > 0 || authLoading

  return (
    <div css={styles().form.main}>
      <form
        css={styles().form.content.main}
        onSubmit={(e) => {
          e.preventDefault()
          setSendDelay(delaySec)
          dispatch(authSendVerificationEmail())
        }}
      >
        <div css={styles().form.content.submit}>
          <ButtonLarge
            type="submit"
            aria-label="Send password reset"
            disabled={submitDisabled}
            appearance="primary"
          >
            {((loading: boolean, delay: number) => {
              // if loading render the loader
              if (loading) {
                return <Loader width={50} height={20} appearance="primary" />
              }

              // if send delayed render the delay count
              if (delay > 0) {
                return `${delay}`
              }

              return `Resend`
            })(authLoading, sendDelay)}
          </ButtonLarge>
        </div>
      </form>
    </div>
  )
}

VerificationForm.propTypes = {}
